var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '#000000' : _b, rest = __rest(_a, ["fill"]);
    return (_jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 12C4 7.5816 7.5816 4 12 4C16.4184 4 20 7.5816 20 12C20 16.4184 16.4184 20 12 20C7.5816 20 4 16.4184 4 12ZM14.9656 10.9656C15.1113 10.8147 15.192 10.6126 15.1901 10.4029C15.1883 10.1931 15.1042 9.99247 14.9559 9.84415C14.8075 9.69582 14.6069 9.61168 14.3971 9.60986C14.1874 9.60804 13.9853 9.68867 13.8344 9.8344L11.2 12.4688L10.1656 11.4344C10.0147 11.2887 9.81264 11.208 9.60288 11.2099C9.39312 11.2117 9.19247 11.2958 9.04415 11.4441C8.89582 11.5925 8.81168 11.7931 8.80986 12.0029C8.80804 12.2126 8.88867 12.4147 9.0344 12.5656L10.6344 14.1656C10.7844 14.3156 10.9879 14.3998 11.2 14.3998C11.4121 14.3998 11.6156 14.3156 11.7656 14.1656L14.9656 10.9656Z", fill: fill }) })));
});
